import { Content } from '@radix-ui/react-accordion';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const StyledAccordionPanel = styled(motion(Content))<{
    $scrollBarColor?: string;
    $containScroll?: boolean;
}>`
    && {
        box-sizing: border-box;
        color: white;
        overflow: hidden scroll;

        ${({ $containScroll }) =>
            $containScroll
                ? css`
                      overscroll-behavior: contain;
                  `
                : null}

        /* scrollbar styling */
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => theme.shades.white[10]} transparent;

        ::-webkit-scrollbar {
            width: 0.1875rem;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
        ::-webkit-scrollbar-thumb {
            background: ${({ theme, $scrollBarColor }) => ($scrollBarColor ? $scrollBarColor : theme.shades.white[10])};
        }
    }
`;

export const StyledContainer = styled(motion.div)<{ $noBorder?: boolean }>`
    && {
        margin: 0;
        padding: 0;
        border-bottom: ${({ $noBorder }) => ($noBorder ? 'none' : `1px solid #ffffff1a`)};
        box-sizing: border-box;
        position: relative;
    }
`;

export const StyledList = styled.ul<{ $direction: 'row' | 'column'; $paddingTop?: number }>`
    && {
        margin: 0 5px 0 0;
        padding: ${({ $paddingTop }) => $paddingTop || 0}px 0 0 0;
        list-style: none;
        display: flex;
        gap: 10px 8px;
        flex-direction: ${({ $direction }) => $direction};
        flex-wrap: ${({ $direction }) => ($direction === 'row' ? 'wrap' : 'nowrap')};
    }
`;

export const StyledItem = styled.li`
    && {
        overflow: hidden;
    }
`;
